<template>
 <div>
    <CookieConsent/>
    <router-view/>
    <Footer/>
    <switcher/>

 </div>
</template>

<script setup> 
import { useI18n } from 'vue-i18n'
//const { t } = useI18n() 
const { t, locale } = useI18n({ useScope: 'global' })
</script>

<script>
  import feather from 'feather-icons'
  import Switcher from '@/components/Switcher.vue'
  import Footer from '@/components/Footer.vue'
  import CookieConsent from '@/components/CookieConsent.vue'
  

export default {
  mounted() {
      feather.replace();
  },
  components:{
        Switcher, Footer
    },
}
</script>
